const headlessCmsModule = {
  namespaced: true,
  state: {
    slotData: {},
    isLoadingCMS: false,
  },
  mutations: {
    setSlotData(state, value) {
      value.forEach((slot) => {
        state.slotData[slot.position] = slot.components;
      });
    },
    setCMSLoadingState(state, isLoading) {
      state.isLoadingCMS = isLoading;
    },
  },

  getters: {
    componentsBySlotPosition: (state) => (slotPosition) => {
      return state.slotData[slotPosition];
    },
  },
};

export default headlessCmsModule;
